import StakeVisual from './StakeVisual'
import BetVisual from './BetVisual'
import ClimbVisual from './ClimbVisual'
import CashoutVisual from './CashoutVisual'
import BustVisual from './BustVisual'
import WinVisual from './WinVisual'

// Render the step's visual via a static switch (rather than a dynamic component
// variable) so each JSX reference is stable across renders.
export const renderVisual = (key, family) => {
  switch (key) {
    case 'STAKE':
      return <StakeVisual />
    case 'BET':
      return <BetVisual />
    case 'CLIMB':
      return <ClimbVisual family={family} />
    case 'CASHOUT':
      return <CashoutVisual />
    case 'BUST':
      return <BustVisual family={family} />
    case 'WIN':
      return <WinVisual />
    default:
      return <StakeVisual />
  }
}
